import { AxiosResponse } from 'axios';
import { BookingType } from 'config';

export type CartStatus =
  | 'EMPTY'
  | 'STARTED'
  | 'ABANDONED'
  | 'PROCESSING'
  | 'ERROR'
  | 'COMPLETE';

export enum CartError {
  AllBookingsFailed = 'all_bookings_failed',
  MultiBookingTimeout = 'batch_booking_timeout',
  NotBookable = 'not_bookable',
  MaxDailyLimit = 'max_daily_limit',
  MaxTotalLimit = 'max_total_limit',
  PaymentMethodFailed = 'payment_method_failed',
  InvalidPaymentMethod = 'invalid_payment_method',
  InvalidParticipants = 'invalid_participants',
  InvalidAvailability = 'invalid_availability',
  InvalidCartStatus = 'invalid_cart_status',
  CartIsComplete = 'cart_is_complete',
}

export type CartCheckoutMethod = 'AVAILABILITY' | 'PROPOSAL';

export interface AvailabilityItem {
  availability: string;
  start?: string;
  end?: string;
  status?: 'BOOKED' | 'ERROR';
  error?: AvailabilityItemError;
}

export type AvailabilityItemError =
  | 'AVAILABILITY_NOT_BOOKABLE'
  | 'PAYMENT_METHOD_FAILED'
  | 'MAX_DAILY_BOOKINGS'
  | 'MAX_TOTAL_BOOKINGS'
  | 'OTHER';

export interface Cart {
  created: string;
  id: string;
  modified: string;
  availability: string | AvailabilityItem[];
  participants: string[];
  paymentMethod: string;
  price: string;
  status: CartStatus;
  checkoutMethod: CartCheckoutMethod;
  bookingType: BookingType;
  user: number;
  instructor?: number;
  facility?: number;
  messageId?: number;
}

export interface CustomProposalPrice {
  price: number;
  extraParticipantPrice: number;
}

export interface Api {
  list: () => Promise<AxiosResponse<Cart[]>>;
  create: (data) => Promise<AxiosResponse<Cart>>;
  checkout: (
    id: string,
    data: Pick<
      Cart,
      'bookingType' | 'availability' | 'participants' | 'paymentMethod'
    >
  ) => Promise<AxiosResponse<Cart>>;
  batchCheckout: (
    id: string,
    data: Pick<
      Cart,
      'bookingType' | 'availability' | 'participants' | 'paymentMethod'
    >
  ) => Promise<AxiosResponse<Cart>>;
}
